import { createContext, useContext, useMemo } from 'react';

const MultiTabsLiveFeedContext = createContext();

export const MultiTabsLiveFeedProvider = ({
  amplitudeConfig,
  selectedTab,
  setSelectedTab,
  userCanAccessLiveFeed,
  setUserCanAccessLiveFeed,
  unreadGroupPostsCount,
  markGroupPostsReadSinceDate,
  children,
}) => {
  const values = useMemo(
    () => ({
      amplitudeConfig,
      selectedTab,
      setSelectedTab,
      userCanAccessLiveFeed,
      setUserCanAccessLiveFeed,
      unreadGroupPostsCount,
      markGroupPostsReadSinceDate,
      children,
    }),
    [
      amplitudeConfig,
      selectedTab,
      setSelectedTab,
      userCanAccessLiveFeed,
      setUserCanAccessLiveFeed,
      unreadGroupPostsCount,
      markGroupPostsReadSinceDate,
      children,
    ],
  );

  return (
    <MultiTabsLiveFeedContext.Provider value={values}>
      {children}
    </MultiTabsLiveFeedContext.Provider>
  );
};

export const useMultiTabsLiveFeedContext = () =>
  useContext(MultiTabsLiveFeedContext);

export default MultiTabsLiveFeedContext;
